import * as strategies from './storageStrategy';
import {
  LOCAL_STORAGE,
  SESSION_STORAGE,
  COOKIE_STORAGE,
} from './constants';

export const getStorageStrategy = (type = LOCAL_STORAGE) => ({
  [LOCAL_STORAGE]: strategies.localStorageStrategy(),
  [SESSION_STORAGE]: strategies.sessionStorageStrategy(),
  [COOKIE_STORAGE]: strategies.cookieStorageStrategy(),
}[type]);

/**
 * Given a key, return the first matching entry in across all storage strategies.
 * @deprecated Be specific in where the value should reside.
 * @param {string} key The entry key.
 */
export const loadFromAll = (key) => [
  LOCAL_STORAGE,
  SESSION_STORAGE,
  COOKIE_STORAGE,
].find(
  (storage) => load(key, storage)
);

/**
 * Retrieves an entry by its key from a storage strategy.
 * @param {string} key The key of the entry to load.
 * @param {string} storage  An enum storage strategy (LOCAL_STORAGE, SESSION_STORAGE, COOKIE_STORAGE).
 */
export const load = (key, storage) => getStorageStrategy(storage).load({ key });

/**
 * Persists a string value in a chosen storage strategy
 * @param {string} key In which to retrieve the value later.
 * @param {string} value A string to persist.
 * @param {string} storage An enum storage strategy (LOCAL_STORAGE, SESSION_STORAGE, COOKIE_STORAGE).
 * @param {Date} options If supported (COOKIE_STORAGE only at this point), the date where this value
 * no longer be available.
 */
export const save = (key, value, storage, options = {}) => {
  const storageStrategy = getStorageStrategy(storage);
  const isExpirySettable = storageStrategy.getConfig().isExpirySupported && options.expiry;
  storageStrategy.save({
    key,
    value,
    expiry: isExpirySettable && options.expiry,
  });
};

/**
 * Removes a entry from a storage strategy.
 * @param {string} key The key of the entry to remove
 * @param {string} storage  An enum storage strategy (LOCAL_STORAGE, SESSION_STORAGE, COOKIE_STORAGE).
 */
export const remove = (key, storage) => getStorageStrategy(storage).remove({ key });
